import script from "./noticeBox.vue?vue&type=script&setup=true&lang=js"
export * from "./noticeBox.vue?vue&type=script&setup=true&lang=js"

import "./noticeBox.vue?vue&type=style&index=0&id=c6b2235e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6b2235e"]])

export default __exports__